import { Component, OnInit, Input, SimpleChanges, OnChanges, Output, EventEmitter } from '@angular/core';
import { Reminder } from 'app/models/dto/reminder.model';
import { CalendarEvent, CalendarView } from 'angular-calendar';
import { Subject } from 'rxjs';
import { NewReminderForm } from 'app/models/dto/new-reminder.model';
import { Alert } from 'app/models/dto/alert.model';
import { isBefore, toDate } from 'date-fns';

const colors: any = {
  green: {
    primary: '#71D18F',
    secondary: '#C1E6CC',
  },
  blue: {
    primary: '#02C0EE',
    secondary: '#D1E8FF',
  },
  yellow: {
    primary: '#F7CC45',
    secondary: '#FDF1BA',
  },
};

@Component({
  selector: 'app-schedule-reminder-borrower',
  templateUrl: './schedule-reminder-borrower.component.html',
  styleUrls: ['./schedule-reminder-borrower.component.scss'],
  standalone: false
})
export class ScheduleReminderBorrowerComponent implements OnInit, OnChanges {

  @Input() reminders: Reminder[];
  @Output() newReminder = new EventEmitter<NewReminderForm>();
  @Output() cancelReminder = new EventEmitter();
  @Output() alert = new EventEmitter<Alert>();

  selectedDateSubject$: Subject<string>;

  view: CalendarView = CalendarView.Day;
  viewDate: Date = new Date();
  refresh: Subject<any> = new Subject();
  events: CalendarEvent[] = [];

  constructor() { }

  ngOnInit(): void {
    this.selectedDateSubject$ = new Subject<string>();
    this.selectedDateSubject$.next(this.viewDate.toDateString());
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.reminders) {
      this.events = [];
      this.reminders.forEach(reminder => {
        this.events.push(this.formatAsCalendarEvent(reminder));
      });
    }
  }

  formatAsCalendarEvent(reminder: any) {
    return {
      reminder: reminder,
      title: reminder.borrower.name,
      color: !isBefore(new Date(reminder.expires), new Date()) && !reminder.occurred ? colors.blue
        : isBefore(new Date(reminder.expires), new Date()) && !reminder.occurred ? colors.yellow
        : colors.green,
      start: new Date(reminder.expiresTimestamp * 1000),
      draggable: false,
      actions: [
        {
          label: reminder.action === 'call' ? '<span class="fa fa-phone"></span>'
            : reminder.action === 'todo' ? '<span class="fa fa-th-list"></span>'
            : reminder.action === 'message' ? '<span class="fa fa-comment"></span>'
            : '',
          onClick: (): void => {},
        },
      ],
    };
  }

  hourSegmentClicked( {date} ) {
    this.setSelectedDate(date);
    this.selectedDateSubject$.next(date.toString());
  }

  emitCancelReminder() {
    this.cancelReminder.emit();
  }

  setSelectedDate(date: Date) {
    this.viewDate = date;
  }

  emitNewReminder(newReminder: NewReminderForm) {
    if (!isBefore(toDate(newReminder.expires * 1000), new Date())) {
      this.newReminder.emit(newReminder);
    } else {
      this.alert.emit({
        message: 'You cannot schedule a reminder in the past.',
        level: 'error',
        dismissDelay: 5000
      });
    }
  }
}
